import styled from 'styled-components';

import { media } from 'utils/detection';
import H1 from 'components/H1';

export default styled(H1)`
  color: ${props => props.theme.textSemiDark};
  width: 100%;
  margin: 8px 0 25px 0;

  ${media.medium`
    order: 2;
    margin: -8px 0 4vw 0;
  `}
`;
